import Marquee from "react-fast-marquee";

const items = [
  "Account Recovery",
  "Platform Errors",
  "Feature Restrictions",
  "Disabled Accounts",
  "Content Problems",
  "General Guidance",
];

export const KineticMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-border py-8 sm:py-10 bg-background overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-black uppercase tracking-tighter text-5xl sm:text-7xl text-stroke px-8">
              {item}
            </span>
            <span className="h-3 w-3 bg-accent rotate-45 mx-2" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default KineticMarquee;
